import { ZoomAppRow } from '../components/zoom/ZoomAppRow';
import type { AppRow } from '../type/AppRow';

export const zoomAppRow: AppRow = {
  key: 'zoom',
  name: 'Zoom',
  AppComponent: ZoomAppRow,
};
